import { css } from '@emotion/core';
import { variables as vars } from '@domain-group/fe-brary';
var colour = vars.colour;
var _ref = {
  name: "9uy14h",
  styles: "width:24px;height:24px;"
};
var _ref2 = {
  name: "54dvsu",
  styles: "fill:none;"
};
export default _ref3 => {
  var _ref3$activeColour = _ref3.activeColour,
    activeColour = _ref3$activeColour === void 0 ? colour.brandYellow : _ref3$activeColour;
  var icon = _ref;
  var path = _ref2;
  var active = /*#__PURE__*/css("fill:", activeColour, ";");
  return {
    icon,
    path,
    active
  };
};